import React from 'react';
import { TypeMegaMenuComponentWithoutUnresolvableLinksResponse } from '@shared/features/contentful/_generated';
import LightRetouchTextLink from '@shared/light-retouch/components/LightRetouchTextLink/LightRetouchTextLink';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { resolveContentfulTargetProps } from '@shared/features/contentful/linkMap';
import styles from './Footer.module.scss';

interface IFooterBottomMenuProps {
    links: TypeMegaMenuComponentWithoutUnresolvableLinksResponse['fields']['bottomLinks'];
}

const FooterBottomMenu: React.FC<IFooterBottomMenuProps> = ({ links }) => {
    const inspectorProps = useContentfulInspectorMode();

    return (
        <ul className={styles.footerBottomMenu}>
            {links?.map(
                (link) =>
                    link && (
                        <li
                            key={link.sys.id}
                            {...inspectorProps({ entryId: link.sys.id, fieldId: 'title' })}
                        >
                            <LightRetouchTextLink
                                href={link.fields.link ?? '/'}
                                showArrow={false}
                                variant="gold"
                                className="text-sm !font-[400] !text-colourForegroundSecondary"
                                prefetch={false}
                                {...resolveContentfulTargetProps(link.fields.target)}
                            >
                                {link.fields.title}
                            </LightRetouchTextLink>
                        </li>
                    ),
            )}
        </ul>
    );
};

export default FooterBottomMenu;
